const _excluded = ["data-testid", "topSlot", "infoSlot", "issueDateRow", "tableSlot", "notesSlot"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { ConfirmationModal } from 'seagull';
import styles from "./ManualBillModalLayout.module.scss";
export function ManualBillModalLayout(_ref) {
  let {
      ['data-testid']: testId,
      topSlot,
      infoSlot,
      issueDateRow,
      tableSlot,
      notesSlot
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ConfirmationModal, _extends({}, rest, {
    width: "1010px",
    "data-testid": testId,
    textAlignCenter: false,
    content: /*#__PURE__*/React.createElement("div", null, topSlot, infoSlot, /*#__PURE__*/React.createElement("div", {
      className: styles.invoiceCompletionForm
    }, issueDateRow && /*#__PURE__*/React.createElement("div", {
      className: styles.issueDateRow
    }, issueDateRow), tableSlot, notesSlot && /*#__PURE__*/React.createElement("div", {
      className: styles.notes
    }, notesSlot)))
  }));
}